import React, { type ReactNode } from 'react';
import { Box, xcss } from '@atlaskit/primitives';

const fullPageObjectViewWrapperStyles = xcss({
	marginTop: 'space.200',
	marginRight: 'auto',
	marginBottom: 'space.0',
	marginLeft: 'auto',
});

export const FullPageObjectViewWrapper = ({ children }: { children?: ReactNode }) => (
	<Box xcss={fullPageObjectViewWrapperStyles}>{children}</Box>
);
